/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-multi-comp */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prefer-template */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Table } from 'reactstrap';
import {
  // Column,
  useReactTable,
  // ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  getPaginationRowModel,
  // getExpandedRowModel,
  // sortingFns,
  // getSortedRowModel,
  // FilterFn,
  // SortingFn,
  // ColumnDef,
  flexRender,
  // FilterFns,
} from '@tanstack/react-table';
import NoDataFound from 'components/NoDataFound';
import { RiArrowDownSFill, RiArrowUpSFill, RiSearchLine } from 'react-icons/ri';
import { BiTrash } from 'react-icons/bi';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../Loader';

// import {
//   RankingInfo,
//   rankItem,
//   compareItems,
// } from '@tanstack/match-sorter-utils'

// declare module '@tanstack/table-core' {
//   interface FilterFns {
//     fuzzy: FilterFn<unknown>
//   }
//   interface FilterMeta {
//     itemRank: RankingInfo
//   }
// }

// const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
//   // Rank the item
//   const itemRank = rankItem(row.getValue(columnId), value)

//   // Store the itemRank info
//   addMeta({
//     itemRank,
//   })

//   // Return if the item should be filtered in/out
//   return itemRank.passed
// }

// const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
//   let dir = 0

//   // Only sort by rank if the column has ranking information
//   if (rowA.columnFiltersMeta[columnId]) {
//     dir = compareItems(
//       rowA.columnFiltersMeta[columnId]?.itemRank!,
//       rowB.columnFiltersMeta[columnId]?.itemRank!
//     )
//   }

//   // Provide an alphanumeric fallback for when the item ranks are equal
//   return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir
// }

export const FSBTable = ({
  wrapperClass,
  tableWraperClass = '',
  loading,
  handlePageChange,
  defaultSorting,
  tableClass = '',
  onSelectedRowsChange = () => {},
  onRowClick,
  state,
  sorting,
  // getExpandedRowModel,
  isRowExpanded,
  onSortChange,
  searchPlaceholder,
  onGlobalSearch,
  data = [],
  columns = [],
  SubComponent = null,
  currentPageNo = 1,
  totalPages = 0,
  pageSize = 0,
  totalCount = null,
  showSearch = false,
  showFilters = false,
  showDelete = false,
  showPagination = true,
  globalSearchStr = '',
  rowSelection = {},
  getTableInstance = () => {},
  getRowClassName = () => '',
  isMatrixTable = false,
  onCellClick,
  headerSubRow = null,
  showHeader = true,
  ...rest
}) => {
  const [columnFilters, setColumnFilters] = useState([]);

  // const [globalFilter, setGlobalFilter] = useState('');
  // const [sorting, setSorting] = useState([]);
  // const [rowSelection, setRowSelection] = useState({});
  const [expanded, setExpanded] = useState(isRowExpanded);

  // useEffect(() => {
  //   if (onSelectedRowsChange) {
  //     onSelectedRowsChange(rowSelection);
  //   }
  // }, [rowSelection]);

  // const [{ pageIndex, pageSize }, setPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: pageSize,
  // });
  // const pagination = useMemo(
  //   () => ({
  //     pageIndex: currentPageNo,
  //     pageSize,
  //   }),
  //   [currentPageNo, pageSize]
  // );

  const table = useReactTable({
    data,
    columns,
    initialState: {
      sorting: [],
    },
    pageCount: totalPages,
    // filterFns: {
    //   // fuzzy: fuzzyFilter,
    // },
    state: {
      columnFilters,
      rowSelection,
      sorting,
      globalSearchStr,
      // onGlobalSearch,
      // pagination,
      expanded,

      // ...state
    },
    enableRowSelection: true,
    enableColumnFilters: true,
    onRowSelectionChange: onSelectedRowsChange,
    onSortingChange: onSortChange,
    onPaginationChange: handlePageChange,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: onGlobalSearch,
    // globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    onExpandedChange: setExpanded,
    enableSortingRemoval: false,
    manualExpanding: false,
    manualPagination: true,
    manualSorting: true,
    enableFilters: true,
    manualFiltering: true,
    // debugAll: false,
    // debugTable: true,
    // debugHeaders: true,
    // debugColumns: false,

    ...rest,
  });

  useEffect(() => {
    getTableInstance(table);
  }, []);

  const onPageChange = async (pageIndex, pageSize) => {
    await handlePageChange({ pageNo: pageIndex, pageSize });
  };

  const handleRowClick = (row) => {
    if (onRowClick) {
      onRowClick(row);
    }
  };

  const handleCellClick = (item) => {
    if (onCellClick) {
      onCellClick(item);
    }
  };

  return (
    <>
      {showSearch && onGlobalSearch && (
        <DebouncedInput
          value={globalSearchStr ?? ''}
          onChange={(value) => onGlobalSearch(String(value))}
          className="p-2 font-lg shadow border border-block"
          placeholder={searchPlaceholder}
        />
      )}

      <div className="d-flex justify-content-between mb-2 pb-1 entries-row">
        <div className="d-flex">
          {showDelete && (
            <Button
              color="link"
              className="delete-btn d-flex align-items-center"
            >
              <BiTrash className="me-1" /> Delete
            </Button>
          )}
        </div>
      </div>
      <div className={`table-border ${tableWraperClass}`}>
        <Table
          responsive
          className={`${isMatrixTable ? 'matrix-table' : 'common-table'}  mb-0 ${tableClass}`}
        >
          {showHeader && (
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={`header${uuidv4()}`}
                      colSpan={header.colSpan}
                      style={{
                        width: `${header.getSize()}px`,
                        minWidth: `${header.column.columnDef.minSize}px`,
                      }}
                    >
                      {header.isPlaceholder ? null : (
                        <>
                          <div
                            {...{
                              className: header.column.getCanSort()
                                ? 'cursor-pointer select-none'
                                : '',
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                            {{
                              asc: <RiArrowUpSFill size={20} />,
                              desc: <RiArrowDownSFill size={20} />,
                            }[header.column.getIsSorted()] ?? null}
                          </div>
                          {header.column.getCanFilter() ? (
                            <div>
                              {/* <Filter column={header.column} table={table} /> */}
                            </div>
                          ) : null}
                        </>
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
            {headerSubRow && (
              <tr className="table-header-sub-row">
                {headerSubRow}
              </tr>
            )}
            </thead>
          )}
          <tbody>
            {table.getRowModel().rows.length ? (
              table.getRowModel().rows.map((row) => {
                const customRowClass = getRowClassName(row.original, row);
                return (
                  <Fragment key={row.id}>
                    <tr
                      className={`${
                        row.getIsExpanded() ? 'parent-row' : ''
                      } ${onRowClick ? 'table-row-clickable' : ''} ${customRowClass}`.trim()}
                      onClick={() => handleRowClick(row)}
                      role={onRowClick ? 'button' : undefined}
                      tabIndex={onRowClick ? 0 : undefined}
                      onKeyDown={(event) => {
                        if (!onRowClick) return;
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          handleRowClick(row);
                        }
                      }}
                    >
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <td
                            key={cell.id}
                            style={{
                              background: 'white',
                            }}
                            onClick={() => handleCellClick(cell)}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </td>
                        );
                      })}
                    </tr>
                    {SubComponent && row.getIsExpanded() && (
                      <tr className="column-collapse">
                        <td colSpan={row.getVisibleCells().length}>
                          <div className="expanded-row-content">
                            <SubComponent
                              row={row}
                              rows={table.getRowModel().rows}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                );
              })
            ) : loading ? (
              <tr>
                <td className="text-center" colSpan={12}>
                  <Loader size="sm" />
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={16}>
                  <NoDataFound message="No data found!" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="h-2" />
      {showPagination && totalPages ? (
        <div
          className="d-flex mt-3 align-items-center justify-content-end table-pagination-container"
          style={{ paddingRight: '55px' }}
        >
          <span className="text-active text-nowrap f-12">
            {currentPageNo} of {totalPages}
          </span>
          <select
            className="page-select form-select table-select f-12 fw-normal mx-3 d-inline-block"
            value={pageSize}
            // onChange={(e) => {
            //   onPageChange(currentPageNo, Number(e.target.value));
            // }}
            onChange={(e) => {
              if (totalPages === currentPageNo) {
                onPageChange(1, Number(e.target.value));
              } else {
                onPageChange(currentPageNo, Number(e.target.value));
              }
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize} per page
              </option>
            ))}
          </select>
          <div className="pagination">
            <button
              onClick={() => onPageChange(1, pageSize)}
              disabled={currentPageNo <= 1}
            >
              {'<<'}
            </button>
            <button
              onClick={() => onPageChange(currentPageNo - 1, pageSize)}
              disabled={currentPageNo === 1}
            >
              {'<'}
            </button>
            <button
              onClick={() => onPageChange(currentPageNo + 1, pageSize)}
              disabled={currentPageNo >= totalPages}
            >
              {'>'}
            </button>
            <button
              onClick={() => onPageChange(totalPages, pageSize)}
              disabled={currentPageNo >= totalPages}
            >
              {'>>'}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

// function Filter({ column, table }) {
//   const firstValue = table
//     .getPreFilteredRowModel()
//     .flatRows[0]?.getValue(column.id);

//   const columnFilterValue = column.getFilterValue();

//   const sortedUniqueValues = React.useMemo(
//     () =>
//       typeof firstValue === 'number'
//         ? []
//         : Array.from(column.getFacetedUniqueValues().keys()).sort(),
//     [column.getFacetedUniqueValues()]
//   );
//   // console.log("firstValue ", columnFilterValue);
//   return typeof firstValue === 'number' ? (
//     <div>
//       <div className="flex space-x-2">
//         <DebouncedInput
//           type="number"
//           min={Number(column.getFacetedMinMaxValues()?.[0] ?? '')}
//           max={Number(column.getFacetedMinMaxValues()?.[1] ?? '')}
//           value={columnFilterValue?.[0] ?? ''}
//           onChange={(value) => {
//             // column.setFilterValue((old) => [value, old?.[1]])
//           }}
//           placeholder={`Min ${
//             column.getFacetedMinMaxValues()?.[0]
//               ? `(${column.getFacetedMinMaxValues()?.[0]})`
//               : ''
//           }`}
//           className="w-24 border shadow rounded"
//         />
//         <DebouncedInput
//           type="number"
//           min={Number(column.getFacetedMinMaxValues()?.[0] ?? '')}
//           max={Number(column.getFacetedMinMaxValues()?.[1] ?? '')}
//           value={columnFilterValue?.[1] ?? ''}
//           onChange={(value) => {
//             //  column.setFilterValue((old) => [old?.[0], value])
//           }}
//           placeholder={`Max ${
//             column.getFacetedMinMaxValues()?.[1]
//               ? `(${column.getFacetedMinMaxValues()?.[1]})`
//               : ''
//           }`}
//           className="w-24 border shadow rounded"
//         />
//       </div>
//       <div className="h-1" />
//     </div>
//   ) : (
//     <>
//       {/* <datalist id={column.id + "list"}>
//         {sortedUniqueValues.slice(0, 5000).map((value) => (
//           <option value={value} key={value} />
//         ))}
//       </datalist> */}
//       <DebouncedInput
//         type="text"
//         value={columnFilterValue ?? ''}
//         onChange={(value) => {
//           // column.setFilterValue(value)
//         }}
//         placeholder={`Search... (${column.getFacetedUniqueValues().size})`}
//         className="w-36 border shadow rounded"
//         list={column.id + 'list'}
//       />
//       <div className="h-1" />
//     </>
//   );
// }
// const AdvancedFilters = ({ table }) => {
//   // console.log("--- ", table, column);
//   const [showFilters, setShowFilters] = useState(false);
//   const togglePopover = () => {
//     setShowFilters(!showFilters);
//   };
//   const showHeaders = () => {
//     return table?.getAllColumns().map((col) => {
//       if (col?.columnDef) return col?.columnDef?.header;
//     });
//   };

//   return (
//     <div>
//       {/* <Button id="popoverButton" type="button" >
//         {buttonLabel}
//       </Button> */}
//       <Button
//         color="link"
//         id="popoverButton"
//         className="filter-btn me-2 me-md-3"
//         onClick={togglePopover}
//       >
//         Filter <BsFilter />
//       </Button>
//       <Popover
//         placement="bottom"
//         isOpen={showFilters}
//         target="popoverButton"
//         toggle={togglePopover}
//       >
//         <PopoverHeader>Popover Title</PopoverHeader>
//         <PopoverBody>{showHeaders()}</PopoverBody>
//       </Popover>
//     </div>
//   );
// };
// A debounced input react component
function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <div className="table-search">
      <input
        {...props}
        className="form-control"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <RiSearchLine size={22} color="#978E87" />
    </div>
  );
}

FSBTable.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  currentPageNo: PropTypes.number,
  totalPages: PropTypes.number,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  showPagination: PropTypes.bool,
  showSearch: PropTypes.bool,
  showFilters: PropTypes.bool,
  showDelete: PropTypes.bool,
  handlePageChange: PropTypes.func,
  onRowClick: PropTypes.func,
  getRowClassName: PropTypes.func,
  SubComponent: PropTypes.func,
  globalSearchStr: PropTypes.string,
  isMatrixTable: PropTypes.bool,
};
